/* @flow */
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { Translate, I18n } from 'react-redux-i18n'
import Slider from 'react-slick'
import Container from '@material-ui/core/Container'
import Card from '@material-ui/core/Card'
import Grid from '@material-ui/core/Grid'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormGroup from '@material-ui/core/FormGroup'
import Checkbox from '@material-ui/core/Checkbox'
import TextField from '@material-ui/core/TextField'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Chip from '@material-ui/core/Chip'
import { CardContent, CardHeader } from '@material-ui/core';
import { LocationOn, AccessTime, People, AddCircle, DateRange } from '@material-ui/icons'
import Rating from 'react-rating'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import faStar from '@fortawesome/fontawesome-free-regular/faStar'
import faFullStar from '@fortawesome/fontawesome-free-solid/faStar'
import { SingleDatePicker } from 'react-dates'
import moment from 'moment'
import _ from 'lodash'

import './style.css'
import NavArrow from '../../components/NavArrow'
import Button from '../../components/Button'
// import Card from '../../components/Card'
import TimeSection from './TimeSection'
import { SectionHeader } from '../../components/Section'
import { setCurrentOrder } from '../../actions/order'
import { addToFavorite, removeFavorite } from '../../actions/shop'
import { showAlert, showLogin } from '../../actions/global'
import { useSecondaryNavState } from '../../reducers/nav'
import PrimaryInfo from '../../components/PrimaryInfo'
import { useWindowSize } from '../../hooks'
import API from '../../libs/api'

const api = new API()

const FooterToolbar = (props) => {
  const [{ secondaryNav }] = useSecondaryNavState()
  if (!secondaryNav) return null

  const { name, account, currency, total, showLoginAlert, showLogin, showTimeSectionAlert, order, setCurrentOrder, navigate } = props
  return <div className="fixed-footer">
    { name }
    <div className="input-container">
      <Translate value="accountsPayable" className="label" />
      <span className="title">
        {'：'+currency + ' ' + total}
      </span>
    </div>
    <Button
      type="action"
      text={I18n.t('orderNow')}
      onClick={() => {
        if (!account) {
          showLoginAlert()
          showLogin()
        } else {
          if (order.availableList.length > 0 && (!order.timeSection || order.timeSection === -1)) {
            showTimeSectionAlert()
            return
          }
          setCurrentOrder(order)
          navigate('/order')
        }
      }}
    />
  </div>
}

const ActivityContainer = (props) => {
  if (!props.params.activityId) return null

  const { width } = useWindowSize()

  const [initialized, setInitialized] = useState(false)
  const [activity, setActivity] = useState(null)

  const onLoaded = () => {
    setInitialized(true)
  }

  useEffect(() => {
    const slideShowContainer = document.querySelector('.activity-container .slick-list')
    if (slideShowContainer) {
      slideShowContainer.style.maxHeight = (width * 3 / 9) + 'px'
    }
  }, [width, initialized])

  useEffect(() => {
    if (props.params.activityId) {
      api.on('activities/'+props.params.activityId, (val) => setActivity(val))
    }
    return () => {
      api.off('activities/'+props.params.activityId)
    }
  }, [])

  return <Activity {...props} onLoaded={onLoaded} activity={activity} />
}

class Activity extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      startDate: moment(),
      endDate: moment(),
      focused: false,
      startTime: moment().toISOString(),
      endTime: moment().add(30, 'minutes').toISOString(),
      peopleCount: 1,
      timeSections: [],
      timeSection: -1,
      selectedAvailable: null,
      selectedPhoto: null,
      // peopleList: [
      //   { label: 1, value: 1 },
      //   { label: 2, value: 2 },
      //   { label: 3, value: 3 },
      //   { label: 4, value: 4 },
      //   { label: 5, value: 5 },
      //   { label: 6, value: 6 },
      //   { label: 7, value: 7 },
      //   { label: 8, value: 8 },
      //   { label: 9, value: 9 },
      //   { label: 10, value: 10 },
      //   { label: 11, value: 11 },
      //   { label: 12, value: 12 },
      //   { label: 13, value: 13 },
      //   { label: 14, value: 14 },
      //   { label: 15, value: 15 },
      //   { label: 16, value: 16 },
      //   { label: 17, value: 17 },
      //   { label: 18, value: 18 },
      //   { label: 19, value: 19 },
      //   { label: 20, value: 20 },
      // ],
      isTrafficModalOpen: false,
      trafficInfo: null,
      selectedPackageIdx: 0,
    }
  }

  _onPackageSelected = (event) => {
    const idx = event.target.value
    const { activity, params } = this.props
    // const activity = activities[params.activityId]
    const item = activity.packages[idx]
    this.setState({ selectedPackageIdx: idx, peopleCount: item.minPeople > 0 ? item.minPeople : this.state.peopleCount })
  }

  _onUpdateTimeSections = (sections) => {
    this.setState({ timeSections: sections })
  }

  _onOpenTrafficModal = (info) => {
    this.setState({ isTrafficModalOpen: true, trafficInfo: info })
  }

  _onCloseTrafficModal = () => {
    this.setState({ isTrafficModalOpen: false })
  }

  // componentDidUpdate() {
  //   const { activity, initialized } = this.props
  //   console.log('initialized: ', initialized)
  //   if (activity && !initialized) {
  //     this.setState({
  //       startDate: moment(activity.availableList && activity.availableList[0].startDate),
  //       endDate: moment(activity.availableList && activity.availableList[0].startDate)
  //     })
  //   }
  // }

  render() {
    const sliderConfig = {
      dots: true,
      infinite: true,
      speed: 500,
      autoplay: true,
      onInit: this.props.onLoaded,
      prevArrow: <NavArrow icon={() => <i className="icon icon-chevron-dot-prev" />} />,
      nextArrow: <NavArrow icon={() => <i className="icon icon-chevron-dot-next" />} />,
    }

    const { startDate, endDate, focused, peopleCount, timeSections, timeSection, selectedAvailable, isTrafficModalOpen, trafficInfo, selectedPhoto, selectedPackageIdx } = this.state
    const { locations, locale, account, params, activity, shops, currency, setCurrentOrder, navigate, addToFavorite, removeFavorite, showLoginAlert, showLogin } = this.props
    const allLocations = Object.values(locations)
    if (!activity || !allLocations.length) return null
    if (timeSections.length) {
      activity.availableList = timeSections
    }
    const shop = activity && _.find(shops, ['id', activity.shopId])
    const location = shop && _.find(allLocations, (location) => _.includes(location.name, shop.location))
    let favorite
    if (account) {
      favorite = _.find(_.map(account.favorites, (value, key) => ({key, shopId: value.shopId})), { shopId: shop && shop.id })
    }

    let packages = []
    if (activity.packages) {
      packages = activity.packages.map(
        (item, idx) => {
          let beforeFrom = false, afterUntil = false
          if (item.from) {
            const from = moment(item.from)
            if (startDate.isBefore(from)) {
              beforeFrom = true
            }
          }
          if (item.until) {
            const until = moment(item.until)
            if (startDate.isAfter(until)) {
              afterUntil = true
            }
          }
          if (beforeFrom || afterUntil) {
            return null
          }
          return <ListItem key={"package-"+idx}>
            <Grid item container direction="row" justify="space-between">
              <FormControlLabel
                selected={selectedPackageIdx === idx}
                value={String(idx)}
                control={<Radio color="secondary" />}
                label={item.name[locale]}
              />
              <div>{currency.label.toUpperCase() + ' ' + Math.ceil(item.price * currency.ratio * 100) / 100 + ' / ' + I18n.t('people')}</div>
            </Grid>
          </ListItem>
        }
      )
    }
    let notBusinessDay = false
    if (_.filter(packages, p => p).length === 0) {
      packages = [
        <ListItem key={"package-empty"}>
          <Grid item container direction="row" justify="space-between">
            <FormControlLabel
              control={<Radio color="secondary" checked />}
              label={I18n.t('not_business_day')}
              disabled
            />
          </Grid>
        </ListItem>
      ]
      notBusinessDay = true
    }
    
    return <React.Fragment>
      <Slider { ...sliderConfig } className="activity-container">
        { _.map(activity.photos, (photo, idx) => {
            const isDefaultPhoto = !selectedPhoto && idx === 0
            return <img key={'thumb-' + idx}
              className={'thumb' + (photo === selectedPhoto || isDefaultPhoto ? ' active' : '')}
              alt={shop && shop.name[locale]}
              src={photo.url}
            />
          })
        }
      </Slider>
      <Container className="activity-container">
        <Grid
          container
          direction="row"
          className="headline"
        >
          <div className="title">{ activity.name[locale] }</div>
          <Chip label={shop && shop.name[locale]}
            onClick={() => navigate('/shop/'+activity.shopId)}
          />
        </Grid>
        <Grid
          container
          direction="row"
          justify="space-between"
          className="comment"
        >
          <div className="value">{currency.label.toUpperCase() + ' ' + Math.ceil((activity.packages ? activity.packages[0].price : activity.price) * currency.ratio * 100) / 100 }</div>
          { activity.comments &&
            <Grid item direction="row">
              <Rating
                readonly={true}
                emptySymbol={<FontAwesomeIcon size="lg" icon={faStar} color="#009999" />}
                fullSymbol={<FontAwesomeIcon size="lg" icon={faFullStar} color="#009999" />}
                initialRating={activity.rating / 5} />
              <span className="value">({activity.comments ? activity.comments.length : 0})</span>
            </Grid>
          }
        </Grid>
        <Grid
          container
          direction="row"
          className="comment"
          // component="a"
          // name="0"
        >
          <PrimaryInfo icon={<LocationOn />} content={location.name[locale]} />
          <PrimaryInfo icon={<AccessTime />} content={activity.lastFor + I18n.t(activity.lastForUnit)} />
        </Grid>
        <Grid container>
          <div className="desc" dangerouslySetInnerHTML={{__html: activity.intro[locale]}} />
        </Grid>
        <Grid container direction="column" className="intro">
          <SectionHeader titleI18nKey="pricePackages" anchorName="0" />
          <section>
            <List className="desc">
              <RadioGroup aria-label="position" name="position" value={String(selectedPackageIdx)} onChange={this._onPackageSelected}>
                { packages }
              </RadioGroup>
            </List>
            { activity.addons && activity.addons.length > 0 ? (
              <React.Fragment>
                <PrimaryInfo icon={<AddCircle />} content={<Translate value="addons" />} style={{ marginTop: 8 }} />
                <FormGroup>
                  <List>
                  {
                    activity.addons.map((item, idx) => {
                      return <ListItem key={"addon-"+idx}>
                        <Grid item container direction="row" justify="space-between">
                          <FormControlLabel
                            key={'addons-'+idx}
                            control={<Checkbox color="secondary" checked={item.checked} onChange={() => item.checked = !item.checked} value={item.value} />}
                            label={item.name[locale]}
                          />
                          <div>{currency.label.toUpperCase() + ' ' + Math.ceil(item.unitPrice * currency.ratio * 100) / 100}</div>
                        </Grid>
                      </ListItem>
                    })
                  }
                  </List>
                </FormGroup>
              </React.Fragment>
            ) : null}
            <Grid item container className="desc" direction="row">
              <SingleDatePicker
                numberOfMonths={1}
                noBorder={true}
                customInputIcon={<DateRange />}
                displayFormat="YYYY/MM/DD"
                date={startDate} // momentPropTypes.momentObj or null
                onDateChange={(date) => {
                  this.setState({ startDate: date, endDate: date.add(activity.lastFor - 1, activity.lastForUnit) })
                }} // PropTypes.func.isRequired
                focused={focused} // PropTypes.bool
                onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                // isDayBlocked={(day) => !_.find(activity.availableList,
                //   (item) => day.isSameOrAfter(item.startDate, 'day') && day.isSameOrBefore(item.endDate, 'day')
                // )}
              />
              { (activity.lastForUnit === 'hour' || activity.lastForUnit === 'minute') && <AccessTime /> }
              {
                (activity.lastForUnit === 'hour' || activity.lastForUnit === 'minute') && activity.availableList && activity.availableList.length &&
                <TimeSection
                  className="section-menu"
                  activityId={activity.id}
                  date={startDate}
                  value={timeSection}
                  sections={activity.availableList}
                  peopleCount={peopleCount}
                  onChange={(selected) => this.setState(
                    {
                      timeSection: selected,
                      // selectedAvailable: selected.sectionId,
                      // peopleList: Array.from(new Array(selected.remaining), (val, idx) => ({ label: idx+1, value: idx+1 }))
                    }
                  )}
                  onUpdate={this._onUpdateTimeSections}
                  disabled={notBusinessDay}
                />
              }
            </Grid>
            <Grid item container direction="row" className="comment">
              <PrimaryInfo
                icon={<People />}
                content={
                  <React.Fragment>
                    <TextField
                      placeholder={I18n.t('persons')}
                      value={peopleCount}
                      onChange={(e) => {
                        this.setState({ peopleCount: e.target.value })
                      }}
                      type="number"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: activity.packages && activity.packages[selectedPackageIdx].minPeople !== undefined && activity.packages[selectedPackageIdx].minPeople === activity.packages[selectedPackageIdx].maxPeople
                      }}
                      inputProps={{
                        min: activity.packages && activity.packages[selectedPackageIdx].minPeople > 0 ?
                          activity.packages[selectedPackageIdx].minPeople : 1,
                        max: activity.packages && activity.packages[selectedPackageIdx].maxPeople > 0 ?
                          activity.packages[selectedPackageIdx].maxPeople : 99,
                      }}
                      margin="normal"
                      variant="outlined"
                      style={{ minWidth: 200 }}
                    />
                  </React.Fragment>
                }
              />
            </Grid>
          </section>
        </Grid>
        <Grid container direction="column" className="text-left intro">
          <SectionHeader titleI18nKey="activityIntro" anchorName="1" />
          <section>
            <List>
              <ListItem>
                <ListItemText primary={<span><Translate value="lastFor" />： {activity.lastFor + I18n.t(activity.lastForUnit)}</span>} />
              </ListItem>
              <ListItem>
                <ListItemText primary={<span><Translate value="assemblyPlace" />： {activity.assemblyPlace[locale]}</span>} />
              </ListItem>
              {
                activity.courseStructure && <ListItem>
                  <div>
                    <div className="header">
                      <Translate className="title" value="courseStructure" />：
                    </div>
                    <div className="desc">
                      <ul>
                        { activity.courseStructure[locale] && activity.courseStructure[locale].map( (item) => <li key={item} dangerouslySetInnerHTML={{__html: item}}></li> ) }
                      </ul>
                    </div>
                  </div>
                </ListItem>
              }
            </List>
          </section>
        </Grid>
        <Grid container direction="column" className="desc intro">
          <SectionHeader titleI18nKey="activityContents" anchorName="2" />
          <section>
            <List>
            {
              activity.content[locale] && activity.content[locale].map(
                (item) => (
                  <ListItem key={item}>
                    <ListItemText primary={<div dangerouslySetInnerHTML={{__html: item}} />} />
                  </ListItem>
                )
              )
            }
            </List>
          </section>
        </Grid>
        <Grid container direction="column" className="intro">
          <SectionHeader titleI18nKey="activityLimitations" anchorName="3" />
          <section>
            <List className="desc">
            {
              activity.limitation[locale] && activity.limitation[locale].map(
                (item) => (
                  <ListItem key={item}>
                    <ListItemText primary={<div dangerouslySetInnerHTML={{__html: item}} />} />
                  </ListItem>
                )
              )
            }
            </List>
          </section>
        </Grid>
        <Grid container direction="column" className="intro">
          <SectionHeader titleI18nKey="activityNotices" anchorName="4" />
          <section>
            <List className="desc">
            {
              activity.notice[locale] && activity.notice[locale].map(
                (item) => (
                  <ListItem key={item}>
                    <ListItemText primary={<div dangerouslySetInnerHTML={{__html: item}} />} />
                  </ListItem>
                )
              )
            }
            </List>
          </section>
        </Grid>
        <Grid container direction="column" className="intro">
          <SectionHeader titleI18nKey="cancelRules" anchorName="5" />
          <section>
            <List className="desc">
            {
              activity.cancelRule[locale] && activity.cancelRule[locale].map(
                (item) => (
                  <ListItem key={item}>
                    <ListItemText primary={<div dangerouslySetInnerHTML={{__html: item}} />} />
                  </ListItem>
                )
              )
            }
            </List>
          </section>
        </Grid>
        <Grid container direction="column" className="intro">
          <SectionHeader titleI18nKey="assemblyPlace" anchorName="6" />
          <iframe src={"https://www.google.com/maps/embed/v1/place?key=AIzaSyA-B0dh_-HoBK5IAp8s0JPbJbwpMiJWVoA&q="+shop.latlng.lat+","+shop.latlng.lng+"&zoom=16&language=zh-tw"} frameBorder="0" allowFullScreen style={{width: '100%', height: 350}} />
        </Grid>
        { activity.comments && activity.comments.length &&
          (
            <Grid container direction="column" className="intro">
              <SectionHeader titleI18nKey="theComments" anchorName="7" />
              <section>
                <List className="desc">
                { _.map(activity.comments, (comment, idx) =>
                    <Card key={`comment-${idx}`}>
                      <CardHeader
                        title={<div><Translate className="label" value="creator" /> <span className="value">{comment.creatorName}</span></div>}
                        subheader={<div><Translate className="label" value="createdTime" /><div className="value">{moment(comment.createdTime).format('YYYY/MM/DD HH:mm A')}</div></div>}
                      />
                      <CardContent>
                        <div className="row">
                          <Translate className="label" value="rating" />
                          <Rating
                            readonly={true}
                            emptySymbol={<FontAwesomeIcon size="lg" icon={faStar} color="#009999" />}
                            fullSymbol={<FontAwesomeIcon size="lg" icon={faFullStar} color="#009999" />}
                            initialRating={(
                              comment.whole + comment.profession + comment.service + comment.comfort + comment.value
                            ) / 5} />
                        </div>
                        <div className="row">
                          <Translate className="label" value="title" />
                          <div className="value">{comment.title}</div>
                        </div>
                        <div className="row">
                          <Translate className="label" value="content" />
                          <div className="value">{comment.content}</div>
                        </div>
                      </CardContent>
                    </Card>
                  )}
                </List>
              </section>
            </Grid>
          )
        }
        <div className="content" style={{ height: 160 }}>
          {/* <div className="intro">
            <div className="header">
              <FontAwesomeIcon icon={faSquareFull} color="#cc9900" size="xs" />
              <Translate className="title" value="activityFlow" />：
            </div>
            <div className="desc">
              <div className="flow">
              { activity.activityFlow.map( (flow, idx) => (
                  <div key={flow}>
                    <span>{ flow }</span>
                    { idx < (activity.activityFlow.length - 1) ? '→' : null }
                  </div>
                ) )
              }
              </div>
            </div>
          </div>
          <Divider width="100%" height={1} color="#cc9900" /> */}
        </div>
        <FooterToolbar
          name={activity.name[locale]}
          order={{
            ...activity,
            startDate: moment(startDate).format('YYYY/MM/DD'),
            endDate: moment(endDate).format('YYYY/MM/DD'),
            timeSection: activity.lastForUnit !== 'day' ? timeSection : null,
            peopleCount,
            activityId: params.activityId,
            selectedAvailable,
            addons: _.filter(activity.addons, addon => addon.checked),
            packageName: activity.packages[selectedPackageIdx].name,
            price: activity.packages ? activity.packages[selectedPackageIdx].price : activity.price,
          }}
          {...this.props}
          currency={currency.label.toUpperCase()}
          total={(Math.ceil(peopleCount * (activity.packages ? activity.packages[selectedPackageIdx].price : activity.price) * currency.ratio * 100) / 100)}
        />
      </Container>
    </React.Fragment>
  }
}

const mapStateToProps = (state, ownProps) => ({
  locations: state.scene.locations,
  locale: state.i18n.locale,
  account: state.global.user,
  shops: state.shop.shops,
  // activities: state.activity.all,
  params: ownProps.match.params,
  currency: state.global.currency,
})

const mapDispatchToProps = dispatch => ({
  navigate: (location, args) => dispatch(push(location, args)),
  setCurrentOrder: (activity) => dispatch(setCurrentOrder(activity)),
  addToFavorite: (shop) => dispatch(addToFavorite(shop)),
  removeFavorite: (payload) => dispatch(removeFavorite(payload)),
  showLoginAlert: () => dispatch(showAlert(I18n.t('plzLoginFirst'), I18n.t('plzLoginFirst'), 'warning')),
  showTimeSectionAlert: () => dispatch(showAlert(I18n.t('plzSelectTimeSection'), I18n.t('requireTimeSection'), 'warning')),
  showLogin: () => dispatch(showLogin()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ActivityContainer)



// WEBPACK FOOTER //
// ./src/containers/Activity/index.js